import React from 'react'
import { toggleModal } from '../../../reducers/modalReducer'
import { useDispatch } from 'react-redux'

const FractionInvestmentSection = ({ setJourneyModalType }) => {

    const dispatch = useDispatch()
    return (
        <>
            <div className='p5rem FractionInvestmentSection' >
                <div
                    className='p4rem br20px df aic'
                    style={{ backgroundColor: '#101F68' }}
                >
                    <div className='w40'>
                        <img className='w100' src={require('../../../../images/fractional/investment/left.png')} alt="left" />
                    </div>

                    <div className='w60 pl3rem'>
                        <div className='df fdc aifs jcfs'>
                            <h2 className='c1 w100 tal fs3rem fw400' style={{ lineHeight: 1.2 }}>
                                {
                                    window.innerWidth > 992 ?
                                        <>
                                            Not a Hammer. <br></br> A Whole Toolbox
                                        </>
                                        :
                                        'Not a Hammer. A Whole Toolbox'
                                }
                            </h2>
                            <p className='c1 w100 tal fs1rem my1rem' style={{ letterSpacing: 1.5 }}>
                                Diligentsia isn't a rigid, one-size-fits-all tool. Our modular platform <br></br> allows you to deploy the exact solutions your clients need, right when <br></br> they need them.
                            </p>

                            {['Investment Journey', 'Growth Journey', 'Exit Journey'].map((item, id) => {
                                return (
                                    <div
                                        onClick={() => {
                                            setJourneyModalType(item)
                                            dispatch(toggleModal({ open: 'fractionalInvestment' }))
                                        }}
                                        className='bo1 bg44 br50px w250px bss bw1px df aic jcsb py0-5rem px1-5rem mt1rem cp'>
                                        <p className='c1'>{item}</p>
                                        <img src={require('../../../../images/fractional/investment/right-arrows1.svg')} alt="right" />
                                    </div>
                                )
                            })}
                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}

export default FractionInvestmentSection
